import React, { useEffect, useState } from "react";
import avatar from "../assets/icons/user-avatar.png";
import { formatDateTime } from "../utils/FormatDateTime";
import { AiFillDelete } from "react-icons/ai";
import ConfirmModal from "./popups/confirmationModal/ConfirmModal";

const ChatCard = ({ chat, currentUserId, onMessageDelete }) => {
    const [modalIsOpen, setIsChatOpen] = useState(false);
    const [isConfirmDelete, setIsConfirmDelete] = useState(false);

    const isCurrentUser = parseInt(chat.user.id) === parseInt(currentUserId);

    const openModal = () => {        
        setIsChatOpen(true);
    };

    const closeModal = () => {
        setIsChatOpen(false);
    };

    useEffect(() => {
        if (isConfirmDelete) {
            onMessageDelete(chat.comment_id);
            closeModal();
        }
    }, [isConfirmDelete]);

    return (
        <div className={`flex items-end ${isCurrentUser ? "justify-end" : "justify-start"} mb-3`}>
            {/* Profile Image for Other Users */}
            {!isCurrentUser && (
                <img
                    src={chat.user.image || avatar}
                    alt="User"
                    className="w-8 h-8 rounded-full mr-2"
                />
            )}

            {/* Chat Message */}
            <div
                className={`p-3 max-w-md rounded-lg shadow-md ${isCurrentUser ? "bg-green-500 text-white" : "bg-gray-200 text-black"
                    }`}
            >
                {/* User Info */}
                <p className="font-semibold text-sm">
                    {isCurrentUser ? "You" : `${chat.user_phone} | ${chat.user.first_name} ${chat.user.last_name ?? ""}`}
                </p>
                <hr className={`${isCurrentUser ? "border-white" : "border-green-500"} my-1`} />

                {/* Message Text */}
                <p className="text-sm">{chat.comment}</p>

                {/* Timestamp */}
                <div className="flex justify-end text-xs opacity-80 mt-2 gap-1">
                    {formatDateTime(chat.created_at)}
                    <AiFillDelete color="red" className="cursor-pointer" onClick={openModal} />
                </div>
            </div>

            {/* App Icon for Current User */}
            {isCurrentUser && (
                <img src={avatar} alt="Avatar" className="w-8 h-8 rounded-full ml-2" />
            )}
            <ConfirmModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel=""
                onClose={closeModal}
                setIsConfirmDelete={setIsConfirmDelete}
                title="Are you sure, you want to Delete this chat ?"
                icon={<AiFillDelete color="red" size={50} />}
            />
        </div>
    );
};

export default ChatCard;
